import { http } from "@/lib/http";

/**
 * Livestream settings — mirrors Vue2's direct Firestore access
 * (campaigns/livestream doc: { live, teaserImage }) but goes through the
 * backend's /api/campaigns/livestream endpoint instead of the client SDK.
 */
export function fetchLivestream() {
  return http
    .get("/api/campaigns/livestream")
    .then((res) => res.data?.data ?? { live: false, teaserImage: null });
}

export function updateLivestream({ live, teaserImage }) {
  return http
    .post("/api/campaigns/livestream", { live, teaserImage })
    .then((res) => res.data);
}
